/**
 * 礼品
 */

export default {
  // 礼品列表
  giftDataList: `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_PREFIX_STR}/gift/data/list`,
};
